import http from "./http.service";
import { change } from "redux-form";
import Promisable from "./promisable.service";
import { MODAL, modalActions } from "redux/slices/modal";
import { getAppDispatch } from "utils/dispatch.util";
import { paymentActions } from "redux/slices/payment";
import { isYeloAppSession } from "utils/partnerSession.util";

const url = "/payments";

const PaymentService = {
	getClientSecret: async (type?: any, s?: any) => {
		const dispatch = getAppDispatch();
		dispatch?.(modalActions.setLoading(true));

		http.setJWT();
		http.acceptLanguage();

		const [success, error]: any = await Promisable.asPromise(
			http.post(`${url}/s/payment-method`, { paymentType: 'card' })
		);

		dispatch?.(modalActions.setLoading(false));
		return [success, error];
	},

	deleteCreditCard: async (id: string) => {
		const dispatch = getAppDispatch();
		dispatch?.(modalActions.setLoading(true));

		http.setJWT();
		http.acceptLanguage();


		const [success, error]: any = await Promisable.asPromise(
			http.delete(`${url}/s/payment-method/${id}`)
		);

		if (success) {
			await PaymentService.getAllMethods();
			dispatch?.(modalActions.closeModal());
		}

		dispatch?.(modalActions.setLoading(false));
		return [success, error];
	},

	getAllMethods: async () => {
		if (isYeloAppSession()) {
			return [null, null];
		}

		const dispatch = getAppDispatch();
		dispatch?.(paymentActions.setLoading(true));

		http.setJWT();
		http.acceptLanguage();

		const [success, error]: any = await Promisable.asPromise(
			http.get(`${url}/get-all-methods`)
		);

		if (success) {
			const { credit_cards, payment_methods } = success.data.data;
			dispatch?.(
				paymentActions.setMethods({ credit_cards, payment_methods })
			);
		}

		dispatch?.(paymentActions.setLoading(false));
		return [success, error];
	},

	setDefaultMethod: async (data: any) => {
		const dispatch = getAppDispatch();
		dispatch?.(modalActions.setLoading(true));

		http.setJWT();
		http.acceptLanguage();

		const [success, error]: any = await Promisable.asPromise(
			http.post(`${url}/set-default-method`, data)
		);

		if (success) {
			const { credit_cards, payment_methods } = success.data.data;
			dispatch?.(
				paymentActions.setMethods({ credit_cards, payment_methods })
			);
			dispatch?.(modalActions.closeModal());
		}

		dispatch?.(modalActions.setLoading(false));
		return [success, error];
	},

	applyCoupon: async (data: any, t: any) => {
		const dispatch = getAppDispatch();
		dispatch?.(modalActions.setLoading(true));
		http.setJWT()
		http.acceptLanguage();

		const [success, error]: any = await Promisable.asPromise(
			http.post(`coupon/check-coupon`, data)
		);

		if (success) {
			dispatch?.(change("SearchForm", "coupon_code", data.coupon_code));
			dispatch?.(
				change("SearchForm", "discount", success.data.data.discount)
			);
			dispatch?.(
				change("SearchForm", "discount_type", success.data.data.type)
			);
			dispatch?.(
				change("SearchForm", "discounted_price", success.data.data.price)
			);
			dispatch?.(modalActions.closeModal());
		} else {
			if (data.aggregator)
				dispatch?.(
					modalActions.openModal({
						width: "600px",
						type: MODAL.CONFIRMATION_FORM,
						data: {
							id: '',
							type: "campaign",
							heading: t("TermsandConditionsofSaudiFoundationDayPromo"),
							message: error?.response?.data?.message || "",
						},
					})
				)

		}

		dispatch?.(modalActions.setLoading(false));
		return [success, error];
	},
	addPayPal: async (data: any) => {
		const dispatch = getAppDispatch();
		dispatch?.(modalActions.setLoading(true));

		http.setJWT();
		const [success, error]: any = await Promisable.asPromise(
			http.post(`${url}/p/add`, data)
		);

		if (success) {
			// await PaymentService.getAllMethods();
			// dispatch?.(modalActions.closeModal());
		}

		dispatch?.(modalActions.setLoading(false));
		return [success, error];
	},
};

export default PaymentService;
